var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.classes, _vm.collapsed ? `${_vm.baseClass}--collapsed` : '']},[_c('span',{class:`${_vm.baseClass}__text`},[_vm._v("\n    "+_vm._s(_vm.$epb.environment)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }